import { isResourceDetailImage, isResourceDetailVideo, isResourceDetailDocument, isResourceDetailBookmark } from './resourceDetailGuards.js';

const getResourceDimensions = (resource) => {
  if (isResourceDetailImage(resource) || isResourceDetailVideo(resource)) {
    return resource.data.attributes?.dimensions && resource.data.attributes?.dimensions.height && resource.data.attributes?.dimensions.width && {
      width: resource.data.attributes?.dimensions.width,
      height: resource.data.attributes?.dimensions.height
    } || void 0;
  }
  if (isResourceDetailDocument(resource) && resource.data.attributes?.cover && resource.data.attributes.cover.width && resource.data.attributes.cover.height) {
    return {
      width: resource.data.attributes.cover.width,
      height: resource.data.attributes.cover.height
    };
  }
  if (isResourceDetailBookmark(resource) && resource.data.webpage?.image && resource.data.webpage?.image.width && resource.data.webpage?.image.height) {
    return {
      width: resource.data.webpage?.image.width,
      height: resource.data.webpage?.image.height
    };
  }
  return void 0;
};

export { getResourceDimensions };
//# sourceMappingURL=getResourceDimensions.js.map
